 <template>
    <div>
      <div class="technical-drawing-wrapper">
        {{title}}
        <b-button @click="showModal">
          <!-- <img :src="require(`./../assets/technical-drawings/png/elementLengths/plain/elementlengths_jas.png`)"  /> -->
          <!-- <div v-html="require(`./../assets/technical-drawings/${step}/${type}.svg`)"></div> -->

          <div v-if="isIE()" class="ie-img-wrapper">
            <div v-if="step === 'elementLengths'" class="technical-drawings-img-Wrapper ie-elementLengths">
              <img class="highlight highlight-a" :src="require(`./../assets/technical-drawings/png/`+ step + `/a/` + type + `.png` )"  />
              <img class="highlight highlight-a1" :src="require(`./../assets/technical-drawings/png/`+ step + `/a1/` + type + `.png` )"  />
              <img class="highlight highlight-a2" :src="require(`./../assets/technical-drawings/png/`+ step + `/a2/` + type + `.png` )"  />
              <img class="highlight plain" :src="require(`./../assets/technical-drawings/png/`+ step + `/plain/` + type + `.png` )"  />
            </div>
            <div v-if="step === 'elementHeights'" class="technical-drawings-img-Wrapper ie-elementHeights">
              <img class="highlight highlight-c" :src="require(`./../assets/technical-drawings/png/`+ step + `/c/` + type + `.png` )"  />
              <img class="highlight highlight-d1" :src="require(`./../assets/technical-drawings/png/`+ step + `/d1/` + type + `.png` )"  />
              <img class="highlight plain" :src="require(`./../assets/technical-drawings/png/`+ step + `/plain/` + type + `.png` )"  />
            </div>
            <div v-if="step === 'elementWidths'" class="technical-drawings-img-Wrapper ie-elementWidths">
              <img class="highlight highlight-b" :src="require(`./../assets/technical-drawings/png/`+ step + `/b/` + type + `.png` )"  />
              <img class="highlight highlight-e" :src="require(`./../assets/technical-drawings/png/`+ step + `/e/` + type + `.png` )"  />
              <img class="highlight plain" :src="require(`./../assets/technical-drawings/png/`+ step + `/plain/` + type + `.png` )"  />
            </div>
          </div>

          <div v-else v-html="require(`./../assets/technical-drawings/${step}/${type}.svg`)"></div>

        </b-button>
        <button class="icon-search" v-on:click="tdButtonClick()"> + </button>
      </div>
      <b-modal ref="myModalRef" hide-footer>
        <div v-if="isIE()" class="ie-img-wrapper-modal">
          <img :src="require(`./../assets/technical-drawings/png/`+ step + `/all/` + type + `.png` )"  />
        </div>
        <div v-else v-html="require(`./../assets/technical-drawings/${step}/${type}.svg`)"></div>
      </b-modal>
    </div>
</template>

<script>
export default {
  name: 'TechnicalDrawing',
  props: {
    step: String,
    type: String,
    title: String
  },
  components: {
  },
  methods: {
    showModal () {
      this.$refs.myModalRef.show()
      this.tracking(this.$store.currentTabName, 'Bild')
    },
    hideModal () {
      this.$refs.myModalRef.hide()
    },
    tdButtonClick () {
      this.$refs.myModalRef.show()
      this.tracking(this.$store.currentTabName, 'Button')
    },
    tracking: function (headline, type) {
      this.registerUserInput()
      let gtmEvent = 'JKK-Events'
      let gtmEventCategory = 'Technische Zeichnung'
      let gtmEventAction = type
      let gtmEventLabel = this.$t(headline + '.virtualPageTitle')
      let virtualPageURL = '/' + this.$t(this.step + '.virtualPageURL')
      let virtualPageTitle = this.$t(this.step + '.virtualPageTitle')
      this.$root.$children['0'].globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, '', virtualPageURL, virtualPageTitle)
    },
    registerUserInput: function () {
      // this line needs to track only User Input
      this.$root.$children['0'].userDidAction = true
    },
    getImgUrl: function () {
      var images = require.context('./../assets/technical-drawings/png/', false, /\.png$/)
      return images('/img/technical-drawings/png/' + this.step + '/plain/' + this.type + '.png')
    },
    isIE: function () {
      const ua = navigator.userAgent
      /* MSIE used to detect old browsers and Trident used to newer ones */
      const isIe = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1
      return isIe
    }
  },
  mounted: function () {
    // console.log('--- TechnicalDrawing rendert ---')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
